<div class="chart-custom-container">
  <div id="{{chartId}}" class="chart"></div>
</div>
